exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-51477875]{width:320px}.table[data-v-51477875]{margin-top:20px}", ""]);

// exports
